import { render, staticRenderFns } from "./CustomizeButton.vue?vue&type=template&id=e1e63e4c&scoped=true"
import script from "./CustomizeButton.vue?vue&type=script&lang=js"
export * from "./CustomizeButton.vue?vue&type=script&lang=js"
import style0 from "./CustomizeButton.vue?vue&type=style&index=0&id=e1e63e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e63e4c",
  null
  
)

export default component.exports